import { useCardDashboardPedidoStyles } from "./card-dashboard-pedido-styles"
import { useGetPedido } from "../../../../data/api/gestao/pedidos/get-pedido";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { PedidosModel } from "../../../../model/api/pedidos/pedidos-model";
import { useToastSaurus } from "../../../../service/app/use-cases";
import { CircularLoading } from "../../utils";
import { Fade, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import classNames from "classnames";
import { CardNaoEncontrado } from "../card-nao-encontrado";
import { InformacaoIcon } from "../../icons";
import { formatDataHora } from "../../../../utils/format-data-hora";
import { alterarCorSituacaoPedido } from "../../../../utils/alterar-cor-status-pedido";

export const CardDashboardPedido = () => {
    const classes = useCardDashboardPedidoStyles();
    const { getPedido, carregando } = useGetPedido();
    const history = useHistory();
    const { showToast } = useToastSaurus()

    const [queryStatus, setQueryStatus] = useState({
        page: 1,
        totalPages: 0,
        totalResults: 0,
        list: Array<PedidosModel>(),
    });

    const fillResult = useCallback(
        async (
            page: number,
            totalPages: number,
            totalResults: number,
            list: Array<PedidosModel>
        ) => {
            setQueryStatus({
                page: page,
                list: list,
                totalResults: totalResults,
                totalPages: totalPages,
            });
        },
        []
    );

    const search = useCallback(
        async (newPage: number) => {
            try {
                const resGet = await getPedido(newPage)
                if (resGet.erro) throw resGet.erro

                if (
                    resGet.resultado?.data?.pageIndex > resGet.resultado?.data?.totalPage &&
                    resGet.resultado?.data?.totalResult > 0
                ) {
                    search(resGet.resultado?.data?.totalPage);
                    return;
                }

                fillResult(
                    resGet.resultado?.data?.pageIndex,
                    resGet.resultado?.data?.totalPage,
                    resGet.resultado?.data?.totalResult,
                    resGet.resultado?.data?.results
                )
                return resGet;
            } catch (e: any) {
                showToast("error", e.message);
            }
        },
        [getPedido, fillResult, showToast]
    );

    useEffect(() => {
        search(queryStatus.page)
    }, [queryStatus.page, search]);

    const handleClick = () => {
        history.push('/pedidos');
    }

    return (
        <>
            {
                carregando ? (
                    <CircularLoading tipo="FULLSIZED" />
                ) : null
            }
            < Fade in timeout={600} >
                <Tooltip
                    placement='top'
                    title="Clique para ir à tela de Pedidos"
                    classes={{
                        popper: classes.tooltipCustom
                    }}
                >
                    <div className={classes.telaGrid} onClick={handleClick}>
                        {!isEmpty(queryStatus.list) ?
                            <>
                                <Typography className={classes.titleTelas}>Pedidos</Typography>
                                <div className={classes.divider} />
                                <TableContainer component={Paper} className={classes.tableContainerHeaderFixed}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='center'>Aplicação</TableCell>
                                                <TableCell align='center'>Código do Pedido</TableCell>
                                                <TableCell align='center'>Cliente do Pedido</TableCell>
                                                <TableCell align='center'>Valor do Pedido</TableCell>
                                                <TableCell align='center'>Data do Pedido</TableCell>
                                                <TableCell align='center'>Situação</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {queryStatus.list.filter((pedido, i) => i < 10).map((pedido, index) => {
                                            return (
                                                <>
                                                    <TableBody>
                                                        <TableRow key={index} className={classNames(index % 2 === 0 && classes.cardCinza, classes.card)}>
                                                            <TableCell align='center'>{pedido.dadosIntegracao.nomeIntegrador}</TableCell>
                                                            <TableCell align='center'>{pedido.codigoAplicacao}</TableCell>
                                                            <TableCell align='center'>{pedido.cliente.nome}</TableCell>
                                                            <TableCell align='center'>{pedido?.valorTotal?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</TableCell>
                                                            <TableCell align='center'>{formatDataHora(new Date(pedido.dataCriacao))}</TableCell>
                                                            <TableCell align='center'>
                                                                {pedido.tpStatusPedido ? (
                                                                    <Typography
                                                                        className={classes.statusTable}
                                                                        style={{
                                                                            background: alterarCorSituacaoPedido(pedido.tpStatusPedido),
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis'
                                                                        }}
                                                                    >
                                                                        {pedido.tpStatusPedidoDescricao}
                                                                    </Typography>
                                                                ) : (
                                                                    'Sem Situação'
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>

                                                </>
                                            )
                                        })}
                                    </Table>
                                </TableContainer>
                            </>
                            :
                            <CardNaoEncontrado
                                mensagem="Nenhum pedido encontrado."
                                icon={<InformacaoIcon tipo="GERAL" />}
                            />
                        }
                    </div>
                </Tooltip>
            </Fade >
        </>
    )
}

